"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("styled-components").css`
    &.PlannerQuestionnaire {
        width: 100%;
        box-sizing: border-box;
        padding: ${({theme:e})=>e.spacing.xlarge};
        background: ${({theme:e})=>e.colors.common.light};
        box-shadow: ${({theme:e})=>e.shadows.low};
        display: flex;
        flex-direction: column;
        align-items: stretch;

        .PlannerQuestionnaire-trigger {
            margin: ${({theme:e})=>e.spacing.xlarge} auto 0;
        }

        .PlannerQuestionnaire-navigation {
            display: grid;
            grid-template-columns: 75px auto 75px;
            margin-top: ${({theme:e})=>e.spacing.xlarge};

            @media (min-width: 576px) {
                grid-template-columns: 150px auto 150px;
            }

            .DXTypography {
                color: ${({theme:e})=>e.colors.grey[700]};

                &:hover {
                    cursor: pointer;
                }

                svg {
                    fill: ${({theme:e})=>e.colors.grey[700]};
                }
            }

            .PlannerQuestionnaire_navPreviousContainer {
                display: flex;
                flex-wrap: nowrap;
                align-items: center;

                svg {
                    cursor: pointer;
                }

                .PlannerQuestionnaire-previousText {
                    &::before {
                        content: 'Previous Question';
                        margin-left: ${({theme:e})=>e.spacing.xsmall};

                        @media screen and (max-width: 575px) {
                            content: 'Previous';
                        }
                    }
                }
            }

            .PlannerQuestionnaire_navSkipContainer {
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .PlannerQuestionnaire-skipText {
                    &::after {
                        content: 'Skip this Question';

                        @media screen and (max-width: 575px) {
                            content: 'Skip';
                        }
                    }
                }
                svg {
                    transform: rotate(180deg);
                    margin-left: ${({theme:e})=>e.spacing.xsmall};
                    cursor: pointer;
                }
            }
        }

        .PlannerQuestionnaire-counter {
            color: ${({theme:e})=>e.colors.grey[700]};
            text-align: center;

            &::before {
                content: 'Question ';
                @media screen and (max-width: 575px) {
                    display: none;
                }
            }

            span {
                color: ${({theme:e})=>e.colors.primary.default};
                font-weight: 600;
            }
        }
    }
    .invisible {
        visibility: hidden;
    }
`;exports.default=e,exports.styles=e;
//# sourceMappingURL=styles.js.map
